import fileDownload from "js-file-download";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { IAddUpdateOrdersState, IOrderAddUpdateList } from "interfaces/Index";

export const generatePDFHandler = async (
  orderList: IOrderAddUpdateList[],
  orderState: IAddUpdateOrdersState,
  creditAmount: number,
  cash: number,
  isTest?: Boolean
) => {
  const currentDate = moment();
  const formattedDate = currentDate.format("DD-MM-YYYY");
  let salesTaxSum = 0;
  let furtherTaxSum = 0;
  let discountSum = 0;
  let subTotalSum = 0;
  let basketDiscount = orderState.orderDiscount ? orderState.orderDiscount : 0;
  const orderItems = orderList
    .map((item: any) => {
      let subTotal = (item.itemPrice - item.additionalDiscount) * item.quantity;
      return `
    <tr style=" border-bottom: 1px  #E6EDF0 solid;">
      <td class="fontsize-10 padding-style" >${item.itemName}</td>
      <td class="fontsize-9 padding-style">${item.quantity}</td>
      <td class="fontsize-9 padding-style">Rs. ${(
        item.productOriginalPrice -
        item.salesTaxAmount -
        item.furtherTaxAmount
      ).toFixed(2)}</td>
      <td class="fontsize-9 padding-style">${(
        item.discount + item.additionalDiscount
      ).toFixed(2)}</td>
      <td class="fontsize-9 padding-style">${item.salesTaxAmount.toFixed(
        2
      )}</td>
      <td class="fontsize-9 padding-style">${item.furtherTaxAmount.toFixed(
        2
      )}</td>
      <td class="fontsize-9 padding-style">Rs. ${subTotal.toFixed(2)}</td>
    </tr>`;
    })
    .join("");

  orderList.forEach((orderItem: IOrderAddUpdateList) => {
    salesTaxSum += orderItem.salesTaxAmount * orderItem.quantity;
    furtherTaxSum += orderItem.furtherTaxAmount * orderItem.quantity;
    discountSum +=
      (orderItem.discount + orderItem.additionalDiscount!!) *
      orderItem.quantity;
    subTotalSum +=
      (orderItem.productOriginalPrice!! -
        orderItem.salesTaxAmount -
        orderItem.furtherTaxAmount) *
      orderItem.quantity;
  });

  const htmlContent = `<!DOCTYPE html>
  <html lang="en">
     <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoices</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Inter&display=swap" rel="stylesheet">
        <style>

           * {
           font-family: 'Inter', sans-serif;
           }

           table {
           width: 100%;
           border-collapse: collapse;
           }

           th {
           text-align: start;
           }

           td {
           padding-top: 7px;
           padding-bottom: 7px;
           }
          
           th:nth-child(2),
           td:nth-child(2) {
             max-width: 8vw;
          }
         .tableFirstColumnFixedWidth{
            width:130px;
         }
       
          tr:nth-child(4) {
            vertical-align: top;
          }
          .spacingForInvoiceDetails{
            padding-left: 16px;
          }
           .order-items-header {
           color: #69767B;
           font-weight: 600;
           line-height: 14.49px;
           word-wrap: break-word;
           background-color: #F5F7FA;
           color: #69767B;
           }

           .fontsize-10 {
           font-size: 10px;
           }

           .fontsize-12 {
           font-size: 12px;
           }

           .fontsize-9 {
           font-size: 9px;
           }

           .gray6 {
           color: #69767B;
           }

           .padding-style {
           padding: 8.69px 12px 8.69px 12px;
           }

           .font-weight-600{
           font-weight: 800 !important;
           }
        </style>
     </head>
     <body>
        <div style="display:flex; justify-content:space-between">
           <img src="https://assets-global.website-files.com/5eb0899d8fc87851be175c44/655b37cdba7c17f48e28d567_bazaar-new-logo.svg" width="70px" height="52" alt="bazaar-logo">
           <div style="color:#4C4C4C; line-height: 16px;" class="fontsize-10">
              <div style="padding-top:5px; padding-bottom:8px">
                 <span class="font-weight-600 fontsize-10">Address:</span>
                 <span> 47E, 21st Commercial Street, Phase II EXT, DHA Karachi</span>
              </div>
              <span class="font-weight-600 fontsize-10">NTN:</span><span> 8184498-6</span>
           </div>
        </div>
        <div style="display:flex; justify-content:center; border-bottom: 1px #E6EDF0 solid;">
           <h1 style="font-size: 14px; font-weight: 600; line-height: 20px;">Sales Invoice</h1>
        </div>
        <br />
        <table>
           <tr>
              <th class="fontsize-12">Customer Details</th>
              <th></th>
              <th class="fontsize-12 spacingForInvoiceDetails">Invoice Details</th>
              <th class="lastColumnWidth"></th>
           </tr>
           <tr>
              <td class="fontsize-10 tableFirstColumnFixedWidth">Name:</td>
              <td class="fontsize-10">${orderState.customerStore}</td>
              <td class="fontsize-10 spacingForInvoiceDetails ">Invoice Date:</td>
              <td class="fontsize-10 lastColumnWidth">${formattedDate}</td>
           </tr>
           <tr>
              <td class="fontsize-10 tableFirstColumnFixedWidth">NTN:</td>
              <td class="fontsize-10">${orderState.customerNTN}</td>
              <td class="fontsize-10 spacingForInvoiceDetails">Invoice No:</td>
              <td class="fontsize-10 lastColumnWidth">${
                orderState.orderNumber
              }</td>
           </tr>
           <tr>
              <td class="fontsize-10 tableFirstColumnFixedWidth">Address:</td>
              <td class="fontsize-10" >${orderState.customerAddress}</td>
              <td class="fontsize-10 spacingForInvoiceDetails">Order No:</td>
              <td class="fontsize-10 lastColumnWidth">${
                orderState.orderNumber
              }</td>
           </tr>
           </tr>
        </table>
        <br>
        <table>
           <tr class="order-items-header fontsize-10">
              <th class="padding-style">Product Name</th>
              <th class="padding-style">Quantity</th>
              <th class="padding-style">Price (Rs.)</th>
              <th class="padding-style">Discount (Rs.)</th>
              <th class="padding-style">Sales Tax (Rs.)</th>
              <th class="padding-style">Further Tax (Rs.)</th>
              <th class="padding-style">Subtotal (Rs.)</th>
           </tr>
           ${orderItems}
        </table>
        <br>
        <div style="display:flex; justify-content:right; ">
           <table style="width:250px" class="fontsize-9">
              <tr>
                 <td>Subtotal without tax and discount</td>
                 <td class="gray6">Rs. ${subTotalSum.toFixed(2)}</td>
              </tr>
              <tr>
                 <td>Discount</td>
                 <td class="gray6">${
                   discountSum !== 0 ? "-" : ""
                 } Rs. ${discountSum.toFixed(2)}
                 </td>
              </tr>
              <tr>
              <td>Basket discount</td>
              <td class="gray6">${
                basketDiscount !== 0 ? "-" : ""
              } Rs. ${basketDiscount.toFixed(2)}
              </td>
           </tr>
              <tr>
                 <td>Sales Tax</td>
                 <td class="gray6">Rs. ${salesTaxSum.toFixed(2)}</td>
              </tr>
              <tr>
                 <td>Further Tax</td>
                 <td class="gray6">Rs. ${furtherTaxSum.toFixed(2)}</td>
              </tr>
              <tr style="border-top: 1px #E6EDF0 solid;" >
                 <td class="font-weight-600 fontsize-10">Total</td>
                 <td><b>Rs. ${(
                   subTotalSum +
                   salesTaxSum +
                   furtherTaxSum -
                   discountSum -
                   basketDiscount
                 ).toFixed(2)}</b>
                 </td>
              </tr>
              <tr>
              <td>Credit</td>
              <td class="gray6">Rs. ${creditAmount.toFixed(2)}</td>
           </tr>
           <tr>
               <td>Cash</td>
               <td class="gray6">Rs. ${cash.toFixed(2)}</td>
            </tr>
           </table>
        </div>
     </body>
  </html>`;

  const pdfOptions = {
    margin: 10,
    filename: `${orderState.orderNumber}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  };

  if (!isTest) {
    // If not in test mode, call the actual html2pdf function
    html2pdf(htmlContent, pdfOptions).then((pdf: any) => {
      fileDownload(pdf.output("blob"), "custom-pdf.pdf");
    });
  } else {
    // If in test mode, resolve a promise without doing anything
    return Promise.resolve();
  }
};
